export * from './menu';
export { MdMenuTrigger } from './menu-trigger';
export { fadeInItems, transformMenu } from './menu-animations';
export { MdMenu } from './menu-directive';
export { MdMenuItem } from './menu-item';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/menu/index.js
// module id = 379
// module chunks = 3